import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconUserCircle: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9583 9.99984C18.9583 5.05984 14.94 1.0415 10 1.0415C5.06001 1.0415 1.04167 5.05984 1.04167 9.99984C1.04167 12.8915 2.42417 15.4599 4.5575 17.099C4.56083 17.1024 4.56587 17.104 4.5692 17.1074C6.07837 18.2632 7.95749 18.9582 10.0008 18.9582C12.0442 18.9582 13.9234 18.2632 15.4325 17.1074C15.4359 17.104 15.4408 17.1024 15.4441 17.099C17.5758 15.4599 18.9583 12.8915 18.9583 9.99984ZM2.29167 9.99984C2.29167 5.749 5.74917 2.2915 10 2.2915C14.2508 2.2915 17.7083 5.749 17.7083 9.99984C17.7083 12.1023 16.86 14.0099 15.49 15.4016C15.1158 13.8174 13.9183 12.3498 11.425 12.3498H8.57504C6.0817 12.3498 4.88333 13.8174 4.50999 15.4016C3.13999 14.0099 2.29167 12.1023 2.29167 9.99984ZM5.63253 16.3448C5.68087 15.4898 6.0717 13.5998 8.57504 13.5998H11.425C13.9283 13.5998 14.3191 15.4898 14.3675 16.3448C13.125 17.2032 11.6208 17.7082 10 17.7082C8.37917 17.7082 6.87503 17.2023 5.63253 16.3448ZM10.0067 11.4582C11.7292 11.4582 13.1317 10.0565 13.1317 8.33317C13.1317 6.60984 11.7292 5.20817 10.0067 5.20817C8.28422 5.20817 6.88172 6.60984 6.88172 8.33317C6.88172 10.0565 8.28339 11.4582 10.0067 11.4582ZM10.0067 6.45817C11.0401 6.45817 11.8817 7.299 11.8817 8.33317C11.8817 9.36734 11.0401 10.2082 10.0067 10.2082C8.97339 10.2082 8.13172 9.36734 8.13172 8.33317C8.13172 7.299 8.97339 6.45817 10.0067 6.45817Z"
      fill={color}
    />
  </svg>
);

export default IconUserCircle;
